import {
    MyBookingFlightVerification,
    MyBookingFlightVerificationEndPoint,
    MyBookingFlightVerificationRequest,
} from './myBookingFlightVerification.interfaces';
import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { configBase } from '@/config/base';
import { getFakeVerificationResponse } from './myBookingFlightVerification.fake';
import { consoleLog, LogColorType } from '@shared/helpers/log';

const path = configBase.devMode.enabled
    ? 'flightticketverification'
    : 'https://booking-api.sembo.com/flightticketverification';

export class MyBookingFlightVerificationEndpoint
    extends HttpEndpoint
    implements MyBookingFlightVerificationEndPoint
{
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async GetFlightVerification({
        params,
        iteration,
    }: MyBookingFlightVerificationRequest): Promise<MyBookingFlightVerification | null> {
        consoleLog(LogColorType.Ryanair, `GetFlightVerification iteration: ${iteration}`);

        const response = await this.get<MyBookingFlightVerification | null>(
            this.buildPathWithQuery(path, {
                ...params,
            })
        );

        return response;
    }
}

export class FakeMyBookingFlightVerificationEndpoint
    implements MyBookingFlightVerificationEndPoint
{
    public async GetFlightVerification({
        iteration,
    }: MyBookingFlightVerificationRequest): Promise<MyBookingFlightVerification | null> {
        consoleLog(LogColorType.Ryanair, `GetFakeFlightVerification iteration: ${iteration}`);
        await delay(1000);
        return getFakeVerificationResponse(iteration);
    }
}
